import React from "react";
import { useStopwatch } from "react-timer-hook";
import styles from './timer.module.scss'

const Timer=()=> {

    const stopwatchOffset = new Date();
    const {
      seconds,
      minutes,
      hours,
      isRunning,
      start,
      pause,
      reset
    } = useStopwatch({ autoStart: true, offsetTimestamp: stopwatchOffset });
    const hourTime = hours < 10 ? `0${hours}` : `${hours}`;
    const secondTime = seconds < 10 ? `0${seconds}` : `${seconds}`;
    const minuteTime = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return (
        <div className={styles.time}>
          <span>{hourTime}</span>:<span>{minuteTime}</span>:
          <span>{secondTime}</span>
        </div>
    );
};

export default Timer;